/**
 * Pagination configuration constants
 * These are generic pagination options used across the application
 */

export const SHOW_ALL_ITEMS_QUANTITY = 100;

export const QUANTITY_OPTIONS = [
  { id: 10, name: '10 por página' },
  { id: 25, name: '25 por página' },
  { id: 50, name: '50 por página' },
  { id: SHOW_ALL_ITEMS_QUANTITY, name: 'Todos os documentos' },
];

export const DEFAULT_PAGE_SIZE = 25;

export type QuantityOption = (typeof QUANTITY_OPTIONS)[number];

/** Registration tabs list no documents: only the "all" option carries that noun. */
export const REGISTRATION_QUANTITY_OPTIONS: QuantityOption[] = QUANTITY_OPTIONS.map((option) =>
  option.id === SHOW_ALL_ITEMS_QUANTITY ? { ...option, name: 'Todos os registros' } : option
);

export const PHYSICAL_LOCATION_QUANTITY_OPTIONS: QuantityOption[] = QUANTITY_OPTIONS.map((option) =>
  option.id === SHOW_ALL_ITEMS_QUANTITY ? { ...option, name: 'Todos os locais' } : option
);
